export const $e = {
	company: {
		has: {
			changed: true,
		},
	},

	system: {
		booted: true,

		needs: {
			approval: true,
			reload: true,
			configReload: true,
			notificationPermission: true,
			tour: true,
			pin: true,
			notificationCount: true,
		},

		has: {
			notificationPermission: true,
			notification: true,
			confirmation: true,
		},
	},

	echo: {
		OrderStatusChanged: true,
		OrderUpdated: true,
	},

	app: {
		loaded: true,
		loadFailed: true,
		reloaded: true,
		
		mainActionPrompt: {
			shown: true,
			hidden: true,
		},

		indicator: {
			process: {
				start: true,
				end: true,
			},
		},

		needs: {
			search: true,
			mainActionPrompt: true,

			to: {
				scrollToTop: true,
				askForPermission: true,
				closeMainActionPrompt: true,
			},
		},

		has: {
			noDeliveriesMessage: true,
			selectedOrderItems: true,
			selectedOrders: true,
		},
	},

	ui: {
		not: {
			need: {
				actionsForm: true,
			},
		},

		needs: {
			offcanvas: {
				nav: true,
				addressList: true,
			},
			loginForm: true,
			actionsForm: true,
			purchaseView: true,
		},
	},

	user: {
		authenticated: true,
		loggedOut: true,
		updated: true,

		needs: {
			update: true,
			temporaryAvr: true,
			quickUpdate: true,
			fcmTokenUpdate: true,
			authentication: true,
			emailLogin: true,
			googleLogin: true,
			appleLogin: true,
			logout: true,
			information: true,
			otherUserInformation: true,
			to: {
				seePin: true,
				change: {
					onlineStatus: true,
				},
			},

			password: {
				reset: true,
				link: true,
				change: true,
			},

			referFriend: true,
			referFriendMedia: true,
			profileModal: true,
			authCheck: true,
			awards: true,
			transfers: true,
		},

		has: {
			emailLoginError: true,
			information: true,
			fcmToken: true,
			updateError: true,
			logoutError: true,
			blocked: true,
			unblocked: true,
			changed: {
				onlineStatus: true,
			},
		},

		profilePicture: {
			changed: true,

			needs: {
				change: true,
				storage: true,
				pictureForm: true,
			},

			has: {
				storageError: true,
			},
		},

		is: {
			loggingOut: true,
			loggingIn: true,
		}
	},

	location: {
		is: {
			needed: true,
			available: true,
			decoded: true,
		},
		needs: {
			decode: true,
		},
		has: {
			decodeError: true,
		}
	},

	map: {
		needs: {
			interface: true,
		},

		has: {
			location: true,
		},
	},

	order: {
		statusChanged: true,
		paymentRefunded: true,
		surplusClaimed: true,
		surplusPaid: true,

		needs: {
			catalog: true,
			businessOrders: true,
			markAsProcessing: true,
			markAsReady: true,
			deletion: true,
			display: true,
			payment: true,
			filter: true,
			statusChange: true,
			massStatusChange: true,
			completionCode: true,
			paymentRefund: true,
			surplusComputation: true,
			processForm: true,
			refresh: true,

			to: {
				close: {
					processForm: true,
				},
			},
		},

		has: {
			businessOrders: true,
			updatedStatus: true,
			statusChangeError: true,
		},

		is: {
			transferred: true,
		},
	},

	errand: {
		task: {
			needs: {
				completion: true,
			}
		}
	},

	deliverer: {
		has: {
			arrived: true,
		},
		needs: {
			orderStatus: true,
			allDeliverers: true,
			to: {
				transferOrder: true,
			},
		},
		is: {
			online: true,
			offline: true,
		}
	},

	review: {
		stored: true,
		updated: true,
		deleted: true,

		needs: {
			creation: true,
			update: true,
			deletion: true,
			reviewForm: true,
			storage: true,
		},

		has: {
			storageError: true,
		},
	},


	payment: {
		stored: true,
		failed: true,
		completed: true,

		needs: {
			creation: true,
			collection: true,
		},

		has: {
			processingError: true,
		},
	},

	paymentRequest: {
		stored: true,
		deleted: true,

		needs: {
			allRequests: true,
			payment: true,
			creation: true,
			storage: true,
			requestForm: true,
			deletion: true,
		},

		has: {
			allRequests: true,
			storageError: true,
			deletionError: true,
		},
	},

	purchase: {
		stored: true,
		completed: true,
		failed: true,

		needs: {
			creation: true,
			form: true,
			storage: true,
			confirmation: true,
			display: true,
			refresh: true,
		},

		has: {
			storageError: true,
			completionError: true,
			displayError: true,
			refreshError: true,
		},

		is: {
			confirming: true,
			refreshing: true,
		},
	},

	analytics: {
		needs: {
			event: true,
		},
	},

	capa: {
		deposited: true,
		transferred: true,
		withdrawn: true,

		needs: {
			deposit: true,
			depositForm: true,
			withdraw: true,
			withdrawForm: true,
			purchase: true,
			payment: true,
			balance: true,
			transfer: true,
			transferForm: true,
			to: {
				initiateTransfer: true,
				initiateWithdraw: true,
			},
		},

		is: {
			depositing: true,
		},

		has: {
			depositError: true,
			balance: true,
			transferError: true,
			withdrawError: true,
		},
	},

	surplus: {
		claimed: true,
		reimbursed: true,
		customerReimbursed: true,
		reimbursementCompleted: true,
		reimbursementFailed: true,

		needs: {
			claim: true,
			negativeReimbursement: true,
			positiveReimbursement: true,
			processReimbursement: true,
			form: true,
		},

		has: {
			claimError: true,
			reimbursementError: true,
		},

		is: {
			confirming: true,
		},
	},

	setting: {
		updated: true,

		needs: {
			information: true,
			update: true,
		},

		has: {
			information: true,
		},
	},

	qr: {
		needs: {
			scan: true,
			creation: true,
			scanForm: true,
			resultHandling: true,
			code: true,
		},

		has: {
			visibleForm: true,
			scanResult: true,
		},
	},

	image: {
		needs: {
			view: true,
		},
	},

	hashtag: {
		name: {
			available: true,
		},

		location: {
			stored: true,
			needs: {
				storage: true,
			},
		}
	},

	termsAndConditions: {
		accepted: true,
		declined: true,

		needs: {
			acceptance: true,
		},
	},

	appReview: {
		needs: {
			prompt: true,
			rateNow: true,
			remindLater: true,
		},

		shown: true,
		dismissed: true,
	},

	featureAnnouncements: {
		needs: {
			// Queue up (and show, if nothing is currently showing) one or
			// more "what's new" feature-announcement walkthroughs.
			// Payload: { featureAnnouncements }
			prompt: true,
		},

		shown: true,
		dismissed: true,
	},
};
